import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Container, Row, Spinner } from 'reactstrap';
import progileBg from '../../../assets/images/profile-bg.png';
import iconeIntegration from '../../../assets/images/icone_integracoes.png';
import ApiService from "../util/ApiService";

const Integrations = () => {
    document.title = "Integrações | Plantão Rápido";

    const [selectedIntegration, setSelectedIntegration] = useState(null);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0, lastPage: 0 });
    const [integrations, setIntegrations] = useState([]);
    const [loading, setLoading] = useState(false);
    const [credentialsData, setCredentialsData] = useState({});

    const handleList = async (page = 1) => {
        try {
            setLoading(true);
            const response = await ApiService.send('post', process.env.REACT_APP_URL_API + 'integration/list', { page }, true);
            const { data, pagination: pagInfo } = ApiService.handleApiResponse(response);

            setIntegrations(data || []);
            setPagination(pagInfo || { current: 1, pageSize: 10, total: 0 });

            const savedId = localStorage.getItem('selectedIntegrationId');
            if (savedId && data) {
                const integration = data.find(item => item.id === parseInt(savedId));
                if (integration) {
                    setSelectedIntegration(integration);
                    localStorage.removeItem('selectedIntegrationId');
                }
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };


    const handleConnect = async (integrationId) => {
        try {
            const payload = { integration_id: integrationId };

            if (selectedIntegration?.need_credentials && Object.keys(credentialsData).length > 0) {
                payload.credentials = credentialsData;
            }

            const response = await ApiService.send(
                'post',
                process.env.REACT_APP_URL_API + 'integration/connect',
                payload,
                true
            );
            localStorage.setItem('selectedIntegrationId', integrationId);
            if (response?.data?.redirect_url && integrationId !== 2 ) {
                window.location.href = response.data.redirect_url;
            } else {
                ApiService.handleApiMessage(response);
                handleList();
            }
        } catch (error) {
            ApiService.handleApiError(error);
        }
    };

    const handleDisconnect = async (integrationId) => {
        try {
            const response = await ApiService.send(
                'delete',
                process.env.REACT_APP_URL_API + `integration/disconnect/${integrationId}`,
                {},
                true
            );
            localStorage.setItem('selectedIntegrationId', integrationId);
            ApiService.handleApiMessage(response);
            setSelectedIntegration(null);
            handleList();
        } catch (error) {
            ApiService.handleApiError(error);
        }
    };

    const handleChangeCredential = (field, value) => {
        setCredentialsData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    useEffect(() => {
        handleList();
    }, []);

    const renderIcloudInstructions = (credentials) => {
        const url = `${process.env.REACT_APP_URL_API}calendar/${credentials}.ics`;

        return (
            <div className="alert alert-info mt-4">
                <h6><i className="fa-solid fa-calendar-days me-2"></i>Seu link de calendário:</h6>
                <div className="d-flex align-items-center">
                    <code style={{ wordBreak: 'break-all', flex: 1 }}>{url}</code>
                    <button
                        onClick={() => navigator.clipboard.writeText(url)}
                        className="btn btn-sm btn-outline-primary ms-2"
                    >
                        Copiar
                    </button>
                </div>
                <p className="mt-3 mb-0">
                    Para visualizar seus plantões no iPhone ou Mac:
                    <ol className="mt-2">
                        <li>Copie o link acima</li>
                        <li>No iPhone: Ajustes → Calendário → Contas → Outra → Adicionar Calendário Assinado</li>
                        <li>Cole o link e toque em Avançar</li>
                    </ol>
                </p>
            </div>
        );
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="position-relative mx-n4 mt-n4">
                        <div className="profile-wid-bg profile-setting-img">
                            <img src={progileBg} className="profile-wid-img" alt="Background" />
                        </div>
                    </div>

                        <Row>
                        <Col xxl={4} className="h-100">
                            <Card className="mt-n5 h-100 d-flex flex-column">
                                <CardBody className="p-4 text-center">
                                    <h5>Integrações</h5>
                                    {loading ? (
                                        <Spinner color="primary" />
                                    ) : (
                                        <ul className="list-unstyled mt-3">
                                            {integrations.map((item) => (
                                                <li
                                                    key={item.id}
                                                    onClick={() => {
                                                        setSelectedIntegration(item);
                                                        setCredentialsData({});
                                                    }}
                                                    className={`integration-item ${selectedIntegration?.id === item.id ? 'active' : ''}`}
                                                    style={{ cursor: 'pointer', margin: '10px 0' }}
                                                >
                                                    {item.name}
                                                    {item.connected && (
                                                        item.connected.status === 1 ? (
                                                            <i className="mdi mdi-check-circle-outline text-success ms-2" title="Conectado"></i>
                                                        ) : (
                                                            <i className="mdi mdi-close-circle-outline text-danger ms-2" title="Desconectado"></i>
                                                        )
                                                    )}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>

                        <Col xxl={8} className="h-100">
                            <Card className="mt-xxl-n5 h-100 d-flex flex-column">
                                <CardBody className="p-4">
                                    {selectedIntegration ? (
                                        <div>
                                            <h5>{selectedIntegration.name}</h5>
                                            <p dangerouslySetInnerHTML={{__html: selectedIntegration.description}}></p>
                                            <p><strong>Categoria:</strong> {selectedIntegration.category}</p>

                                            {selectedIntegration.need_credentials && selectedIntegration.provider !== 'google_calendar' && selectedIntegration.provider !== 'icloud_calendar' ? (
                                                <form onSubmit={(e) => {
                                                    e.preventDefault();
                                                    handleConnect(selectedIntegration.id);
                                                }}>
                                                    {(selectedIntegration.credentials_fields || []).map((field, index) => (
                                                        <div className="mb-3" key={index}>
                                                            <label className="form-label">
                                                                {field.charAt(0).toUpperCase() + field.slice(1)}
                                                            </label>
                                                            <input
                                                                type={field === 'password' ? 'password' : 'text'}
                                                                className="form-control"
                                                                name={field}
                                                                value={credentialsData[field] || ''}
                                                                onChange={(e) => handleChangeCredential(field, e.target.value)}
                                                                required
                                                            />
                                                        </div>
                                                    ))}

                                                    {selectedIntegration.connected ? (
                                                        selectedIntegration.connected.status ? (
                                                            <button
                                                                type="button"
                                                                className="btn-sm btn btn-danger"
                                                                onClick={() => handleDisconnect(selectedIntegration.id)}
                                                            >
                                                                Desconectar
                                                            </button>
                                                        ) : (
                                                            <button
                                                                type="submit"
                                                                className="btn-sm btn btn-warning"
                                                            >
                                                                Reativar
                                                            </button>
                                                        )
                                                    ) : (
                                                        <button
                                                            type="submit"
                                                            className="btn-sm btn btn-success"
                                                        >
                                                            Enviar Credenciais
                                                        </button>
                                                    )}
                                                </form>
                                            ) : (
                                                <>
                                                    {selectedIntegration.connected && selectedIntegration.connected.status != '3' ? (
                                                        selectedIntegration.connected.status ? (
                                                            <>
                                                                <button
                                                                    type="button"
                                                                    className="btn-sm btn btn-danger mb-3"
                                                                    onClick={() => handleDisconnect(selectedIntegration.id)}
                                                                >
                                                                    Desconectar
                                                                </button>

                                                                {selectedIntegration?.provider === 'icloud_calendar' &&

                                                                    renderIcloudInstructions(selectedIntegration.connected.credentials)}
                                                            </>
                                                        ) : (
                                                            <button
                                                                type="button"
                                                                className="btn-sm btn btn-warning"
                                                                onClick={() => handleConnect(selectedIntegration.id)}
                                                            >
                                                                Reativar
                                                            </button>
                                                        )
                                                    ) : (
                                                        <button
                                                            type="button"
                                                            className="btn-sm btn btn-success"
                                                            onClick={() => handleConnect(selectedIntegration.id)}
                                                        >
                                                            Conectar
                                                        </button>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    ) : (
                                        <div className="text-center p-4">
                                            <img
                                                src={iconeIntegration}
                                                alt="Integrações"
                                                className="mb-3 img-fluid rounded"
                                                style={{maxWidth: '100%', height: 'auto'}}
                                            />
                                            <h5 className="mb-2 text-primary">Integrações inteligentes</h5>
                                            <p className="text-muted">
                                                Conecte seu calendário favorito e mantenha seus plantões sempre
                                                sincronizados.<br/>
                                                Selecione uma integração à esquerda para começar.
                                            </p>
                                        </div>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Integrations;
